import { render, staticRenderFns } from "./KomedexPage.vue?vue&type=template&id=aaecdb72&"
import script from "./KomedexPage.vue?vue&type=script&lang=js&"
export * from "./KomedexPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports